import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { PrimarySource } from 'src/app/models/obs/primarysource';
import { Log } from 'src/app/models/user-log';
import { PrimarysourceService } from 'src/app/services/obs/primarysource.service';
import { Tier3Service } from 'src/app/services/obs/tier3.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { UserLogService } from 'src/app/services/user-log.service';
import { UtilLogService } from 'src/app/services/util/util-log.service';

@Component({
  selector: 'app-admprimarysource-form',
  templateUrl: './admprimarysource-form.component.html',
  styleUrl: './admprimarysource-form.component.scss'
})
export class AdmprimarysourceFormComponent implements OnInit {
  isBlockedTier3: boolean = false;
  form: FormGroup;
  source: PrimarySource = null;

  edit: boolean = false;
  idtier3Selected: number = null;

  constructor(
    private t3Service: Tier3Service,
    private router: Router,
    private sourceS: PrimarysourceService,
    private fb: FormBuilder,
    private activedRoute: ActivatedRoute,
    private utilLogservice: UtilLogService,
    private tokenStorage: TokenStorageService
  ) { }

  ngOnInit() {
    const params = this.activedRoute.snapshot.params;
    this.createForm();
    this.getPrimarySource(params);
  }

  createForm() {
    this.form = this.fb.group({
      id: [null],
      idtier3: [null],
      title: ['', Validators.required],
      url: ['', Validators.required],
      touchedBy: [''],
      status: []
    })
  }

  getPrimarySource(params: any) {
    if (params.id) {
      this.sourceS.getOne(params.id)
        .subscribe(
          res => {
            this.source = res['data'];
            this.idtier3Selected = this.source.idtier3;
            this.getIsBlockedTier3(this.idtier3Selected);
            this.loadData();
            this.edit = true;
          },
          err => console.error(err)
        );
    } else if (params.idtier3) {
      this.idtier3Selected = params.idtier3;
      this.getIsBlockedTier3(this.idtier3Selected);
      this.edit = false;
    }
  }

  loadData() {
    this.form.reset(this.source);
  }

  cancel() {
    this.router.navigate(['/adm/fuente/list/' + this.idtier3Selected]);
  }

  save() {
    if (this.form.invalid) {
      console.log("Form inválido");
      return Object.values(this.form.controls).forEach(control => {
        if (control instanceof FormGroup) {
          Object.values(control.controls).forEach(control => control.markAsTouched());
        } else {
          control.markAsTouched();
        }
      });
    } else {
      this.edit ? this.update(this.form.value.id, this.form.value) : this.create(this.form.value);
      /* this.router.navigate(['/adm/fuente/list']); */
    }
  }

  dataLog = {};
  create(source: PrimarySource) {
    delete source.id;
    source.idtier3 = +this.idtier3Selected;
    source.touchedBy = this.tokenStorage.getUser().nombre;
    this.sourceS.create(source)
      .subscribe(
        res => {
          // Crear el log de actividad del usuario
          if (res) this.utilLogservice.createLog(res['data'], 'creación', 'fuentes primarias');
          this.router.navigate(['/adm/fuente/list/' + this.idtier3Selected]);
        },
        err => { console.error(err) }
      );
  }

  update(id: string, graph: PrimarySource) {
    const data = { ...graph };
    delete graph.id;
    graph.touchedBy = this.tokenStorage.getUser().nombre;
    this.sourceS.update(id, graph)
      .subscribe(
        res => {
          // Crear el log de actividad del usuario
          if (res) this.utilLogservice.createLog(data, 'edición', 'fuentes primarias');
          this.router.navigate(['/adm/fuente/list/' + this.idtier3Selected]);
        },
        err => { console.error(err) }
      );
  }

  campoNoValido(campo: string) {
    return this.form.get(campo).invalid && this.form.get(campo).touched;
  }

  getIsBlockedTier3(id: number) {
    this.t3Service.idT3blocked(id).subscribe({
      next: res => {
        this.isBlockedTier3 = res['isBlocked'];
      },
      error: err => { console.log(err); }
    })
  }
}
